import './style'
import App from './app'
// import eruda from 'eruda';
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// eruda.init();
export default App
